import AuthFooterScreen from "../../../component/layout/authfooter";
import LogoImg from "@/../../public/images/pelorus-logo.svg";
import Welcomeback from "@/../../public/images/welcomeback.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FaRegEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import { TbUserScan } from "react-icons/tb";
import { IoKeyOutline } from "react-icons/io5";
import { LuBuilding2 } from "react-icons/lu";

import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { useLocation } from "react-router-dom";
import { AppRoute } from "../../../router/routerConstants";
import { useState } from "react";
import * as yup from "yup";
import { ValidationCons } from "../../../validation/validationConstant";
import { useFormik } from "formik";
import { showError } from "../../../utils/Common";
import { registerUserApi } from "../../../service/apis/auth.api";

const AddPasswordScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const location = useLocation();
  const { jobId } = location?.state || {};
  const empFormUrl = location.pathname.split("/")[1];
  const [isJobSeekerRegister] = useState(
    state.role === "jobseeker" ? true : false
  );
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isCnfPasswordVisible, setIsCnfPasswordVisible] = useState(false);

  const backButtonStateChange = (e: React.MouseEvent<HTMLButtonElement>) => {
    const params = {
      firstName: state.firstName,
      lastName: state.lastName,
      emailAddress: state.emailAddress,
      password: registerStep2Formik.values.password,
      cnfPassword: registerStep2Formik.values.cnfPassword,
      role: state.role,
      jobId: jobId,
    };

    NavigateTo(AppRoute.AGENT_REGISTER, false, params);
  };
  const registerStep2Formik = useFormik({
    initialValues: {
      password: state.password || "",
      cnfPassword: state.cnfPassword || "",
      isPasswordVisible: false,
      isCnfPasswordVisible: false,
    },
    validationSchema: yup.object({
      password: yup
        .string()
        .trim()
        .min(8, ValidationCons.PASSWORD_CASE)
        .max(15, "Password must not exceed 15 characters")
        .required(ValidationCons.PASSWORD_REQUIRED)
        .matches(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,15}$/,
          ValidationCons.PASSWORD_MATCH
        ),
      cnfPassword: yup
        .string()
        .trim()
        .min(8, ValidationCons.PASSWORD_CASE)
        .required(ValidationCons.CONFIRM_PASSWORD_REQUIRED)
        .matches(/\w/, ValidationCons.PASSWORD_VALID)
        .oneOf([yup.ref("password")], ValidationCons.PASSWORD_MISMATCH),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        const bodyData = {
          firstName: state.firstName,
          lastName: state.lastName,
          email: state.emailAddress,
          password: values.password,
          role: state.role,
        };
        const response = await registerUserApi(bodyData);

        if (response?.user?.id) {
          const states = {
            firstName: state.firstName,
            lastName: state.lastName,
            email: state.emailAddress,
            role: state.role,
            userId: response.user.id,
            tokenData: response.tokens,
            jobId: jobId,
          };

          // dispatch(setUser(response.user));
          // localStorage.setItem("access_token", response.tokens.access);
          // localStorage.setItem("refresh_token", response.tokens.refresh);
          if (empFormUrl === "emp") {
            NavigateTo(AppRoute.EMPLOYEE_REGISTER_STEP3, false, states);
          } else {
            NavigateTo(AppRoute.AGENT_REGISTER_STEP3, false, states);
          }

          setLoading(false);
        } else {
          setLoading(false);

          if (response?.status === 'fail' && response?.message !== "Email already exists") {
            showError(response?.message || "Something went wrong");
          } 
          // else if (response?.message) {
          //   showSuccess(response?.message);
          // }
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.message);
      }
    },
  });
  return (
    <>
      <header className="header common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo text-left">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */ }
                <a onClick={() => NavigateTo(AppRoute.SPLASH)}>
                  <img src={LogoImg} alt="logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main-authModule">
        <section className="welcomebodylogin common-padd">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 leftlargeImg">
                <img src={Welcomeback} alt="Logo"/>
              </div>
              <div className="col-lg-6">
                <div className="welcome-holder">
                  <h1>Create an Account</h1>
                  <p>
                    Enter your personal details to create an account and start
                    journey with us.
                  </p>
                  <div className="login-form-area agent-steper add-password-form mt-5">
                    <Form onSubmit={registerStep2Formik.handleSubmit}>
                      <div className="stepbar">
                        <ul>
                          <li className="checked">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <FaCheck />
                                </span>
                              </div>
                              <p>Step 1</p>
                              <h4>Personal Info</h4>
                            </a>
                          </li>
                          <li className="inprogress">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <IoKeyOutline />
                                </span>
                              </div>
                              <p>Step 2</p>
                              <h4>Password</h4>
                            </a>
                          </li>
                          <li className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <TbUserScan />
                                </span>
                              </div>
                              <p>Step 3</p>
                              <h4>Verification</h4>
                            </a>
                          </li>
                          {!isJobSeekerRegister && (
                            <li className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a>
                                <div className="icon-progress">
                                  <span>
                                    <LuBuilding2 />
                                  </span>
                                </div>
                                <p>Step 4</p>
                                <h4>
                                  {empFormUrl === "emp"
                                    ? "Company Info"
                                    : "Agent Info"}
                                </h4>
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>
                      <h3>Add Password</h3>
                      <Form.Group
                        className="mb-3 position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type={`${isPasswordVisible ? "text" : "password"}`}
                          placeholder="Enter your password"
                          name="password"
                          style={{ backgroundImage: "none" }}
                          onChange={registerStep2Formik.handleChange}
                          onBlur={registerStep2Formik.handleBlur}
                          value={registerStep2Formik.values.password}
                          isInvalid={
                            !!registerStep2Formik.errors.password &&
                            Boolean(registerStep2Formik.touched.password)
                          }
                        />
                        <div
                          className={`eye-icon ${
                            isPasswordVisible ? "red" : ""
                          }`}
                        >
                          {isPasswordVisible ? (
                            <FaRegEye
                              onClick={() => setIsPasswordVisible(false)}
                            />
                          ) : (
                            <FaRegEyeSlash
                              onClick={() => setIsPasswordVisible(true)}
                            />
                          )}
                        </div>
                        <Form.Control.Feedback type="invalid">
                          {typeof registerStep2Formik.errors.password ===
                            "string" && registerStep2Formik.errors.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        className="mb-3 position-relative"
                        controlId="formConfirmPassword"
                      >
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type={`${isCnfPasswordVisible ? "text" : "password"}`}
                          placeholder="Re-enter your password to confirm"
                          name="cnfPassword"
                          style={{ backgroundImage: "none" }}
                          onChange={registerStep2Formik.handleChange}
                          onBlur={registerStep2Formik.handleBlur}
                          value={registerStep2Formik.values.cnfPassword}
                          isInvalid={
                            !!registerStep2Formik.errors.cnfPassword &&
                            Boolean(registerStep2Formik.touched.cnfPassword)
                          }
                        />
                        <div
                          className={`eye-icon ${
                            isCnfPasswordVisible ? "red" : ""
                          }`}
                        >
                          {isCnfPasswordVisible ? (
                            <FaRegEye
                              onClick={() => setIsCnfPasswordVisible(false)}
                            />
                          ) : (
                            <FaRegEyeSlash
                              onClick={() => setIsCnfPasswordVisible(true)}
                            />
                          )}
                        </div>

                        <Form.Control.Feedback type="invalid">
                          {typeof registerStep2Formik.errors.cnfPassword ===
                            "string" && registerStep2Formik.errors.cnfPassword}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <div className="btn-holder d-flex mt-5">
                        <Button
                          className="btn btn-black w-100 btn-primary"
                          variant="primary"
                          type="button"
                          onClick={backButtonStateChange}
                        >
                          Back
                        </Button>
                        <Button
                          className="btn btn-black w-100 btn-primary"
                          variant="primary"
                          type="submit"
                        >
                          {loading ? "Saving ..." : "Next"}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />
    </>
  );
};
export default AddPasswordScreen;
